<template>
    <div class="tabsViews_box" style="height:34px;margin:1px 10px;">
         <scroll-pane ref="scrollPane" class="tags-view-wrapper" >
             <el-tag
                 style="margin: 4px 0px 4px 7px;"
                 class="cursors"
                 size="small"
                 :effect="isActive == tag.path ? 'dark':'plain'"
                 v-for="tag in dynamicTags"
                 :key="tag.meta.index"
                 :closable ="tag.meta.name == '首页'? false: true"
                 :disable-transitions="true"
                 @click="handleClick(tag)"
                 @close="handleClose(tag)">
                 {{tag.meta.name}}
             </el-tag>
         </scroll-pane>
    </div>
 </template>
 <script>
 import ScrollPane from "./ScrollPane";
 import { mapState, mapMutations, mapActions } from "vuex";
 export default {
     name:"tabsViews",
     components: { ScrollPane },
     computed:{
        dynamicTags(){
            return this.$store.state.visitedViews;
        },
        cachedViews(){
            return this.$store.state.cachedViews;
        }
     },
     watch:{
        $route(val){
            let a = {
                meta: val.meta,
                name: val.name,
                path: val.path,
            };
            // 存值Tabs
            let tabArr = [];
            Object.assign(tabArr,this.dynamicTags);
            this.isActive = val.path;
            //先判断是否不需要缓存的，不需要缓存的也不会需要tabs
            if (this.noCacheArr.some(v => v === a.name)) return
             
            //判断当前的路由是否存在过
            if (tabArr.some(v => v.path === val.path)) return
            tabArr.push(a);
            this.saveVisitedViews(tabArr);
 
            //存值缓存 
            let currentName = _.map(tabArr,'name');
            //删除home页，首页不需要缓存
            if(currentName.indexOf('home') != -1){
                currentName.splice(currentName.indexOf('home'),1);
            }
             
            this.saveCachedViews(currentName); // 存值
         },
         isActive(val){
            this.saveLogUrl(val);
         }
     },
     data(){
        return{
            //不需要缓存的
            noCacheArr : [],
            isActive:'', //当前的路由
        }
     },
    mounted(){
        let tabArr = [{
        meta: {index: 3, name: "首页"},
        name: "home",
        path: "/home",
        }];
        this.saveVisitedViews(tabArr); // 存值
        this.saveCachedViews(''); // 存值
        this.isActive = '/home';
    },
    methods:{
        ...mapActions([  
            'saveVisitedViews','saveCachedViews','saveLogUrl'
        ]),
        handleClose(tag) {
            //删除
            let tabArr =[];
            Object.assign(tabArr,this.dynamicTags);
            tabArr.splice(tabArr.indexOf(tag), 1);
            this.saveVisitedViews(tabArr); // 存值
            this.saveCachedViews(_.map(tabArr,'name')); // 存值
            //删除当前的tabs,路由跳转到最后一个，否则不跳转
            if(this.isActive == tag.path){
                //获取最后一个
                const latestView = tabArr.slice(-1)[0];
                if (latestView) {
                    //跳转到最后一个
                    this.$router.push(latestView.path);
                }
            }
        },
        handleClick(tag){
            //跳转对应的路由
            this.$router.push(tag.path)
        }
    }
 }
 </script>
 <style>
 .tabsViews_box .el-tag--plain{
    background:#e9f2ff !important;
 }
 </style>


// WEBPACK FOOTER //
// src/views/components/tabsViews.vue